import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ScenarioProvider } from './context/ScenarioContext';
import { Toaster } from './components/ui/sonner';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Ricavi from './pages/Ricavi';
import MixInstallatori from './pages/MixInstallatori';
import MixImpianti from './pages/MixImpianti';
import ProduzioneEUAsia from './pages/ProduzioneEUAsia';
import Costi from './pages/Costi';
import Piani from './pages/Piani';
import Impostazioni from './pages/Impostazioni';
import AnalisiCGAnagrafiche from './pages/AnalisiCGAnagrafiche';
import AnalisiCGRegole from './pages/AnalisiCGRegole';
import AnalisiCGAnalisi from './pages/AnalisiCGAnalisi';
import AnalisiCGDettaglio from './pages/AnalisiCGDettaglio';
import AnalisiCGPartitari from './pages/AnalisiCGPartitari';
import GuidaCGAvanzato from './pages/GuidaCGAvanzato';
import BilanciPeriodo from './pages/BilanciPeriodo';
import PianoConti from './pages/PianoConti';
import KpiConti from './pages/KpiConti';

function FullLoader() {
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <div className="h-12 w-12 rounded-xl bg-black text-white grid place-items-center font-bold animate-pulse">FH</div>
        <span className="text-sm">Caricamento…</span>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return (
    <ScenarioProvider>
      <AppShell>{children}</AppShell>
    </ScenarioProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/ricavi" element={<Protected><Ricavi /></Protected>} />
      <Route path="/ricavi/mix-installatori" element={<Protected><MixInstallatori /></Protected>} />
      <Route path="/ricavi/mix-impianti" element={<Protected><MixImpianti /></Protected>} />
      <Route path="/ricavi/produzione" element={<Protected><ProduzioneEUAsia /></Protected>} />
      <Route path="/costi" element={<Protected><Costi /></Protected>} />
      <Route path="/pianificazione/piani" element={<Protected><Piani /></Protected>} />
      <Route path="/analisi-cg/fier" element={<Navigate to="/analisi-cg/periodi" replace />} />
      <Route path="/analisi-cg/periodi" element={<Protected><BilanciPeriodo /></Protected>} />
      <Route path="/analisi-cg/piano-conti" element={<Protected><PianoConti /></Protected>} />
      <Route path="/analisi-cg/kpi-conti" element={<Protected><KpiConti /></Protected>} />
      <Route path="/analisi-cg/anagrafiche" element={<Protected><AnalisiCGAnagrafiche /></Protected>} />
      <Route path="/analisi-cg/regole" element={<Protected><AnalisiCGRegole /></Protected>} />
      <Route path="/analisi-cg/analisi" element={<Protected><AnalisiCGAnalisi /></Protected>} />
      <Route path="/analisi-cg/partitari" element={<Protected><AnalisiCGPartitari /></Protected>} />
      <Route path="/analisi-cg/analisi/:id" element={<Protected><AnalisiCGDettaglio /></Protected>} />
      <Route path="/analisi-cg/guida" element={<Protected><GuidaCGAvanzato /></Protected>} />
      <Route path="/impostazioni" element={<Protected><Impostazioni /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
